import styled from 'styled-components/macro';
import { getFlex } from '../../styled/styleUtils';

export const StudioWrapper = styled.div``;
export const StudioInner = styled.main`
  ${getFlex('flex-start', 'flex-start')}
`;
